import React from 'react';
import { connect } from 'react-redux';
import { IDispatchProp } from 'restdux';
import {
    Button,
    Collapse,
    Divider,
    ListItem,
    ListItemText,
    Theme,
    Typography,
    withTheme, 
    WithTheme 
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { createStyles, withStyles, WithStyles } from '@material-ui/styles';
import LSVDeleteModal from './DeleteModal';
import LSVEditModal from './AddEditModal';
import LSVUsersManagementModal from './users/ManagementModal';
import LSVORIsManagementModal from './applicantTypes/ManagementModal';
import { IReturn as LivescanVendor, actions as livescanVendorActions } from '../../api/resources/LivescanVendor';

const styles = (theme: Theme) =>
    createStyles({
        content: {
            padding: '8px 16px',
        },
        itemActions: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
        itemSection: {
            flexBasis: '100%',
        }
    });

interface IProps {
    index: number;
    lsv: LivescanVendor;
};

interface IState {
    expanded: boolean;
    showDeleteModal: boolean;
    showEditModal: boolean;
    showUsersModal: boolean;
    showORIsModal: boolean;
}

type FullProps = IProps & WithStyles<typeof styles> & WithTheme & IDispatchProp;
class LSVPanel extends React.PureComponent<FullProps> {
    public state = {
        expanded: false,
        showDeleteModal: false,
        showEditModal: false,
        showUsersModal: false,
        showORIsModal: false
    }
    
    render() {
        const { index, lsv, classes } = this.props;
        const { expanded, showDeleteModal, showEditModal, showUsersModal, showORIsModal } = this.state;

        return (
            <React.Fragment>
                {index !== 0 && (
                <Divider component="li" />
                )}
                <ListItem button onClick={this.handleExpandClick}>
                    <ListItemText className={classes.itemSection} primary={lsv.name} secondary={lsv.public ? (
                        <>
                            Publicly visible
                        </>
                    ) : (
                        <>
                            Hidden
                        </>
                    )} />
                    <ListItemText className={classes.itemSection} secondary={(
                        <>
                            {lsv.location_street1}
                            {lsv.location_street2 && (<><br />{lsv.location_street2}</>)}
                            <br />{lsv.location_city}, {lsv.location_state} {lsv.location_postal}
                        </>
                    )} />
                    {expanded ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <div className={classes.content}>
                        <Typography variant="subtitle2">
                            Point of contact
                        </Typography>
                        <Typography variant="body2">
                            {lsv.contact_first_name} {lsv.contact_last_name}<br />
                            {lsv.contact_email}<br />
                            {lsv.contact_phone}
                        </Typography>
                    </div>
                    <div className={classes.itemActions}>
                        <Button onClick={this.handleORIsClick}>ORIs</Button>
                        <Button onClick={this.handleUsersClick}>Users</Button>
                        <Button onClick={this.handlePublishClick}>{lsv.public ? ("Unpublish") : ("Publish")}</Button>
                        <Button onClick={this.handleDeleteClick}>Delete</Button>
                        <Button onClick={this.handleEditClick} color="primary">Edit</Button>
                    </div>
                </Collapse>
                <LSVDeleteModal open={showDeleteModal} onDismiss={this.handleDeleteDismiss} />
                <LSVEditModal lsv={lsv} open={showEditModal} onDismiss={this.handleEditDismiss} />
                <LSVUsersManagementModal lsv={lsv} open={showUsersModal} onDismiss={this.handleUsersDismiss} />
                <LSVORIsManagementModal lsv={lsv} open={showORIsModal} onDismiss={this.handleORIsDismiss} />
            </React.Fragment>
        )
    }

    private handleExpandClick = () => {
        this.setState({expanded: !this.state.expanded});
    }

    private handleDeleteClick = () => {
        this.setState({showDeleteModal: true});
    }

    private handleDeleteDismiss = async (shouldDelete: boolean) => {
        if (shouldDelete) {
            const { dispatch, lsv } = this.props;
            await dispatch(livescanVendorActions.delete(lsv.id, undefined, undefined));
        }
        this.setState({showDeleteModal: false});
    }

    private handleEditClick = () => {
        this.setState({showEditModal: true});
    }

    private handleEditDismiss = (shouldRefresh: boolean) => {
        this.setState({showEditModal: false});
    }

    private handlePublishClick = () => {
        const { dispatch, lsv } = this.props;
        dispatch(livescanVendorActions.update(lsv.id, {public: !lsv.public})).catch(console.error);
    }

    private handleUsersClick = () => {
        this.setState({showUsersModal: true});
    }

    private handleUsersDismiss = () => {
        this.setState({showUsersModal: false});
    }

    private handleORIsClick = () => {
        this.setState({showORIsModal: true});
    }

    private handleORIsDismiss = () => {
        this.setState({showORIsModal: false});
    }
}

export default connect()(withTheme(withStyles(styles)(LSVPanel)));